import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import { myFormControlLabelProps as Props } from "../../types/doctorInfo.types";

const CustomFormControlLabel: React.FC<Props> = ({ value }) => {
  return (
    <React.Fragment>
      <FormControlLabel
        value={value}
        control={<Radio checkedIcon={<CheckCircleIcon />} />}
        label={
          <Typography
            sx={{
              fontFamily: "Avenir",
              letterSpacing: "0px",
              color: "#333333",
              opacity: 1,
              fontSize: { xs: "14px", sm: "16px", md: "18px", xl: "24px" },
              lineHeight: { xs: "20px", sm: "22px", md: "26px", xl: "33px" },
            }}
          >
            {value}
          </Typography>
        }
        sx={{
          background: "#2685F826 0% 0% no-repeat padding-box",
          border: "1px solid #2685F899",
          borderRadius: "10px",
          opacity: 1,
          width: { xs: "220px", sm: "223px", md: "223px", xl: "291px" },
          height: { xs: "40px", sm: "44px", md: "44px", xl: "58px" },
          marginBottom: "10px",
          marginLeft: 0,
          color: "#333333",
        }}
      />
    </React.Fragment>
  );
};

export default CustomFormControlLabel;
